import { render, staticRenderFns } from "./PackageSummary.vue?vue&type=template&id=18e3ee1a&scoped=true"
import script from "./PackageSummary.vue?vue&type=script&lang=js"
export * from "./PackageSummary.vue?vue&type=script&lang=js"
import style0 from "./PackageSummary.vue?vue&type=style&index=0&id=18e3ee1a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e3ee1a",
  null
  
)

export default component.exports